function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\uD83C\uDF08 COLOR");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-layer-group",
  transform: "translate(-2.000000, -1.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M2.49999207,8.86 L11.4999921,14.06 C11.8094011,14.2386328 12.1905989,14.2386328 12.4999921,14.06 L21.4999921,8.86 C21.8075445,8.6824477 21.9978565,8.35511106 22.0000079,8 C22.001424,7.64131524 21.8106342,7.30934096 21.4999921,7.13 L12.4999921,1.93999999 C12.1905989,1.76136719 11.8094011,1.76136719 11.4999921,1.93999999 L2.49999207,7.13 C2.1893658,7.30934096 1.99857598,7.64131524 1.99999207,8 C2.00214345,8.35511106 2.19245545,8.6824477 2.49999207,8.86 Z M12,3.99999999 L19,7.99999999 L12,12 L4.99999999,7.99999999 L12,3.99999999 Z M20.5,11.17 L12,16 L3.49999999,11.13 C3.26947626,10.996455 2.9951937,10.9604163 2.73799633,11.0298783 C2.48079897,11.0993404 2.26195121,11.2685603 2.12999999,11.5 C1.85861169,11.9779792 2.02386357,12.5853915 2.49999999,12.86 L11.5,18.06 C11.8094011,18.2386328 12.1905989,18.2386328 12.5,18.06 L21.5,12.86 C21.9761364,12.5853915 22.1413883,11.9779792 21.87,11.5 C21.7380488,11.2685603 21.519201,11.0993404 21.2620037,11.0298783 C21.0048063,10.9604163 20.7305237,10.996455 20.5,11.13 L20.5,11.17 Z M20.5,15.17 L12,20 L3.49999999,15.13 C3.26947626,14.996455 2.9951937,14.9604163 2.73799633,15.0298784 C2.48079897,15.0993404 2.26195121,15.2685603 2.12999999,15.5 C1.85861169,15.9779792 2.02386357,16.5853915 2.49999999,16.86 L11.5,22.06 C11.8094011,22.2386328 12.1905989,22.2386328 12.5,22.06 L21.5,16.86 C21.9761364,16.5853915 22.1413883,15.9779792 21.87,15.5 C21.7380488,15.2685603 21.519201,15.0993404 21.2620037,15.0298784 C21.0048063,14.9604163 20.7305237,14.996455 20.5,15.13 L20.5,15.17 Z",
  id: "\\uD83C\\uDF08-COLOR"
})));

var SvgActivities = function SvgActivities(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "22px",
    viewBox: "0 0 20 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgActivities, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/activities.68257461.svg";
export { ForwardRef as ReactComponent };